<template>
	<div class="room-detail">
		<v-layout row wrap mb-3 align-items-center>
			<v-flex md8>
				<media :item="mediaItem"></media>
			</v-flex>
			<v-flex md4>
				<v-layout row wrap justify-end align-items-center>
					<div class="pr-2">
						<room-status class="mb-0" v-bind:clean-state="room.clean_state" v-bind:number="room.number"
						  v-bind:code="room.code" v-bind:status-icon="room.icon" v-bind:room="room"
						  v-bind:size="'medium'" v-bind:extra-state="room.extra_state" v-bind:name="room.name">
						</room-status>
					</div>
					<div class="time-container body-border-left">
						<clock v-bind:minute="room.time_minute" v-bind:second="room.time_second"
						  v-on:increase-time="increaseTime" />
					</div>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<list-detail-description :details="mediaItem.details" class="px-2 mb-3"></list-detail-description>
		</v-layout>
		<table-run v-bind:columns="columns" v-bind:rows="rows" v-bind:selectable="false"
		  v-bind:include-delete="false" v-bind:include-export-to-excel="true" v-bind:include-options="true"
		  v-bind:include-state="true" v-bind:include-images="true" v-on:on-search-event="onSearchData"
		  v-on:go-to-photos-page="openRoomPhotos" v-on:on-sortable-event="columnSortableEvent"
		  class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{props.row.name}} {{props.row.lastname}}</td>
				<td>{{props.row.date}}</td>
				<td>{{props.row.clean_type}}</td>
				<td>{{props.row.time_standard}}</td>
				<td>{{props.row.time_done}}</td>
				<td>{{props.row.supervisor}}</td>
			</template>
		</table-run>
	</div>
</template>

<script>

import TableRun from 'table-run';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import Clock from '@/components/shared/Clock';
import ListDetailDescription from '@/components/shared/ListDetailDescription';
import FilterList from '@/components/shared/FilterList';
import Media from '@/components/shared/Media';
import RoomStatus from '@/components/shared/RoomStatus';

function created() {
	this.loadData();
}

function columnSortableEvent({ id }) {
	setTimeout(() => {
		let newData = [];
		const newColumn = this.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		const columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		this.rows = newData;
	}, 300);
}

function increaseTime() {
	if (this.room.time_second === 59) {
		this.room.time_minute += 1;
		this.room.time_second = 0;
	} else {
		this.room.time_second += 1;
	}
}

async function loadData(search) {
	try {
		const response = await this.$http.get(`room/${this.roomId}/detail`, { params: { search } });
		this.room = response.data;
		this.rows = response.data.history;
	} catch (error) {
		this.showNotification('Error interno de servidor, por favor recargue la pagina e intentelo de nuevo', 'error');
	}
}

function onSearchData(value) {
	this.loadData(value);
}

function openRoomPhotos(row) {
	this.$router.push({ name: 'room-photos', params: { roomId: this.room.id, roomNumber: this.room.number, maidId: row.id } });
}

function mediaItem() {
	const media = {
		avatar: '/static/img/bed-icon.png',
		title: `Habitacion ${this.room.roomtype_name} - ${this.room.number}`,
		subtitles: [],
		details: [],
	};
	if (this.room.maid) {
		media.subtitles.push({
			key: 'Mucama',
			value: this.room.maid.name,
		});
		media.subtitles.push({
			key: 'Estado',
			value: this.room.maid.state_name,
		});
		media.details.push({
			description: this.room.maid.type_clean,
			icon: 'type-clean',
			label: 'Tipo de Limpieza',
		});
		media.details.push({
			description: this.room.maid.date,
			icon: 'date',
			label: 'Fecha',
		});
		media.details.push({
			description: this.room.maid.standard_time,
			icon: 'time-standard',
			label: 'Tiempo Standard',
		});
		media.details.push({
			description: this.room.maid.supervisor,
			icon: 'supervisor',
			label: 'Supervisora',
		});
	}
	return media;
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
}

export default {
	created,
	name: 'room-detail',
	components: {
		ButtonCreate,
		Clock,
		FilterList,
		ListDetailDescription,
		Media,
		RoomStatus,
		TableRun,
	},
	computed: {
		mediaItem,
	},
	data() {
		return {
			columns: [
				{ id: 1, name: 'Mucamas', code: 'name', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Tipo de limpieza', code: 'clean_type', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Tiempo estandar', code: 'time_standard', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Tiempo realizado', code: 'time_done', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Supervisor', code: 'supervisor', isSortable: { down: true, up: false } },
			],
			rows: [],
			item: {
				avatar: '/static/img/bed-icon.png',
				title: 'Habitación 111 - Deluxe Suite Queen',
				subtitles: [
					{
						key: 'Mucama',
						value: 'María Chiappe',
					},
					{
						key: 'Estado',
						value: 'En curso',
					},
				],
			},
			time: '00:45',
			filterValue: 1,
			room: {
				id: 1,
				roomtype_name: '',
				number: '',
				code: '',
				icon: '',
				extra_state: '',
				clean_state: 0,
				time: '00:00',
			},
		};
	},
	methods: {
		columnSortableEvent,
		increaseTime,
		loadData,
		onSearchData,
		openRoomPhotos,
		selectedFilter,
	},
	mixins: mixin,
	props: ['roomId'],
};
</script>

<style lang="scss" scoped>
.time-container {
	padding-left: 17px;
	width: 165px;
}
</style>




// WEBPACK FOOTER //
// RoomDetail.vue?69f55712